import Vue from 'vue';

// ----------------------------------------------------
//  This class is called 'agile' as in
//  that it has custom helper code made 
//  from 'Agile Interactive'.
// ----------------------------------------------------

const agile =
{
	access:
	{
		SUPER_ADMIN: 'sup',
		DEVELOPER: 'dev',
		ADMIN: 'adm',
		EDITOR: 'edi',
		READER: 'rea',
		GUEST: 'gue',
	},

	// ----------------------------------
	//	Set some custom layout sizes
	// ----------------------------------

	appBarHeight()
	{
		/* switch (window.$vuetify.breakpoint.name)
		{
			case 'xs': return '56'
			case 'sm': return '56'
			case 'md': return '56'
			case 'lg': return '56'
			case 'xl': return '56'
		} */
		return 66;
	},
	appBarTabWidth()
	{
		/* switch (window.$vuetify.breakpoint.name)
		{
			case 'xs': return '56'
			case 'sm': return '56'
			case 'md': return '56'
			case 'lg': return '56'
			case 'xl': return '56'
		} */
		return 82;
	},

	smallTitleBarHeight()
	{
		/* switch (window.$vuetify.breakpoint.name)
		{
			case 'xs': return '40'
			case 'sm': return '50'
			case 'md': return '50'
			case 'lg': return '60'
			case 'xl': return '60'
		} */
		return 36;
	},

	toolBarPrimaryHeight()
	{
		/* switch (window.$vuetify.breakpoint.name)
		{
			case 'xs': return '40'
			case 'sm': return '50'
			case 'md': return '50'
			case 'lg': return '60'
			case 'xl': return '60'
		} */
		return 40;
	},
	toolBarSecondaryHeight()
	{
		/* switch (window.$vuetify.breakpoint.name)
		{
			case 'xs': return '30'
			case 'sm': return '35'
			case 'md': return '35'
			case 'lg': return '40'
			case 'xl': return '40'
		} */
		return 30;
	},

	sortBy: function sortBy(obj, property)
	{
		obj.sort((a,b) => a[property] < b[property] ? -1 : 1)
	},

	sortBySubProperty: function sortBySubProperty(obj, property, subProperty)
	{
		obj.sort((a,b) => a[property][subProperty] < b[property][subProperty] ? -1 : 1)
	},

	// ----------------------------------
	//	User data
	// ----------------------------------

	loggedInUser: Vue.observable(
	{
		uid: '',
		displayName: '',
		firstName: '',
		lastName: '',
		email: '',
		keys: [],
		avatarAbbreviation: '',
		adminInSomeProject: false,
		accessCards: null,
		superAdmin: false,

		currentProject:
		{
			id: '',
			name: '',
			key: '',
			variable: '',
			accessMap: '',
			access: '',
			clientName: '',
			groupName: '',
			prettyName: '',

		},

		projects: [],

	}),


	// --------------------------------------------------------------------
	//
	//	Get projects
	//
	// --------------------------------------------------------------------

	getProjectIdByKey: function(key)
	{
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			if (this.loggedInUser.projects[i].key == key) return this.loggedInUser.projects[i].id;
		}
	},

	
	getProjectByKey: function(key)
	{
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			if (this.loggedInUser.projects[i].key == key) return this.loggedInUser.projects[i];
		}
		// If nothing was returned, return empty project // Todo: yea it suck, and I really want Value objects or something now here
		return {
			id: '',
			name: '',
			key: '',
			variable: '',
			accessMap: '',
			accessLevel: '',
			clientName: '',
			groupName: '',
			prettyName: '',
		}
	},

	getClientNameByKey: function(key)
	{
		
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			//console.log(this.loggedInUser.projects[i].key, key);
			if (key) if (this.loggedInUser.projects[i].key.substring(0,3) === key.substring(0,3)) return this.loggedInUser.projects[i].clientName;
		}

		return null;
	},

	getGroupNameByKey: function(key)
	{
		// Check if the user has exact key for group
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			if (key) if (this.loggedInUser.projects[i].key.substring(0,7) === key.substring(0,7)) return this.loggedInUser.projects[i].groupName;
		}

		// Check if the user has wildcard, access to all groups
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			if (key) if (this.loggedInUser.projects[i].key.substring(0,4)+"*" === key.substring(0,5)) return '*';//this.loggedInUser.projects[i].groupName;
		}

		return null;
	},

	getProjectNameByKey : function(key)
	{
		
		// Check if the user has exact key for project
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			if (key) if (this.loggedInUser.projects[i].key.substring(0,11) === key.substring(0,11)) return this.loggedInUser.projects[i].projectName;
		}

		// Check if the user has group wildcard, access to all groups and projects
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			if (key) if (this.loggedInUser.projects[i].key.substring(0,4)+"*-*" === key.substring(0,7)) return '*';//return this.loggedInUser.projects[i].projectName;
		}

		// Check if the user has project wildcard, access to all projects
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			if (key) if (this.loggedInUser.projects[i].key.substring(0,8)+"*" === key.substring(0,9)) return '*';//return this.loggedInUser.projects[i].projectName;
		}

		return null;
	},

	getClients: function()
	{
		const clientList = [];
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			let hasEntry = false;

			for (let j = 0; j < clientList.length; j++)
			{
				// Prevenet duplicates
				if (clientList[j].name == this.loggedInUser.projects[i].clientName)
				{
					hasEntry = true;
					break;
				}
			}

			if (!hasEntry)
			{
				const entry = this.loggedInUser.projects[i];
				
				clientList.push( {
					access: entry.access,
					name: entry.clientName,
					admin: entry.clientAdmin,
					id: entry.clientId,
					key: entry.clientKey,
					clientKey: entry.clientKey,
					groupKey: '*',
					projectKey: '*',
					hasAdminAccessInSub: entry.projectAdmin
				} );
			}
		}
		return clientList;
	},

	getProjectGroups: function()
	{
		const groupList = [];
		for (let i = 0; i < this.loggedInUser.projects.length; i++)
		{
			let hasEntry = false;

			for (let j = 0; j < groupList.length; j++)
			{
				// Prevenet duplicates
				if (groupList[j].clientName == this.loggedInUser.projects[i].clientName && groupList[j].name == this.loggedInUser.projects[i].groupName)
				{
					hasEntry = true;
					break;
				}
			}

			if (!hasEntry)
			{
				const entry = this.loggedInUser.projects[i];
				groupList.push( {
					access: entry.access,
					clientName: entry.clientName,
					clientId: entry.clientId,
					clientKey: entry.clientKey,
					groupKey: entry.groupKey,
					projectKey: '*',
					name: entry.groupName,
					admin: entry.groupAdmin,
					id: entry.groupId,
					key: entry.groupKey,
					hasAdminAccessInSub: entry.projectAdmin
				} );
			}
		}
		return groupList;
	},

	setCurrentProjectByKey: function(key)
	{
		this.loggedInUser.currentProject = this.getProjectByKey(key);
	},




	// --------------------------------------------------------------------
	//
	//	Set some rules for input fields
	//
	// --------------------------------------------------------------------

	fieldRules:
	{
		emailRules:
		[
			v => !!v || 'Email is wrong',
			v => /.+@.+\..+/.test(v) || 'Email is wrong',
		],

		passwordRules:
		[
			v => !!v || 'Password is too short, must be atleast 6 characters',
			v => (v && v.length > 5) || 'Password is too short, must be atleast 6 characters',
		],

		nameRules: [
			v => !!v || 'Field is required',
			v => (v && v.length >= 1 && v.length <= 80) || 'Name must be more than 1 and less than 50 characters',
		],

		variableRules: [
			v => !!v || 'Variable is required',
			v => (v && v.length >= 2 && v.length <= 50) || 'Variable must be more than 1 and less than 20 characters',
		],

		prefixRules: [
			v => !!v || 'Prefix key is required',
			v => (v && v.length == 3) || 'Prefix must be exactly 3 characters',
		],

		requiredRule: [
			v => !!v || 'Field is required',
		],

		integerRule: [
			v => (!!v || v === 0) || 'Integer is required',
			v => (!isNaN(v)) || 'Must be an integer',
		],

		numberRule: [
			v => (!!v || v === 0) || 'Number is required',
			v => (!isNaN(v)) || 'Must be a number',
		],

	},



	// --------------------------------------------------------------------
	//
	//	Util functions
	//
	// --------------------------------------------------------------------

	getObjectById: function(objectArray, id, /* infinityBreaker = 20 */) // Recursively nested objects in mother array and children arrays
	{
		//if (infinityBreaker === 0) return null;

		let result = null;
		//console.log(".. run");
		if (Array.isArray(objectArray))
		{
			for (let i = 0; i < objectArray.length; i++)
			{
				//console.log("-- Checking:", objectArray[i].id, id);
				if (objectArray[i].id === id)
				{
					return objectArray[i];
				}
				else
				{
					if (objectArray[i].children && objectArray[i].children.length > 0) result = this.getObjectById(objectArray[i].children, id/* , infinityBreaker-1 */);
					if (result != null) return result;
				}
			}
		}
		return null;
	},


	collectObjectsAsIdParentArray: function(object, ar) // #Todo: What a shitty name.....
	{
		ar.push(object);
		if (object.children && Array.isArray(object.children))
		{
			for (let i = 0; i < object.children.length; i++)
			{
				this.collectObjectsAsIdParentArray(object.children[i], ar);
			}
		}
	},

	




	getAndRemoveObjectById: function(objectArray, id) // Recursively nested objects in mother array and children arrays
	{
		let result = null;

		if (Array.isArray(objectArray))
		{
			for (let i = 0; i < objectArray.length; i++)
			{
				if (objectArray[i].id === id)
				{
					let o = objectArray[i];
					objectArray.splice(i, 1);
					return o;
				}
				else
				{
					if (objectArray[i].children && objectArray[i].children.length > 0) result = this.getAndRemoveObjectById(objectArray[i].children, id);
					if (result !== null) return result;
				}
			}
		}
		return null;
	},


	recursivelyAddFirestoreBatchDeletes: function(pageTypeCollection, folderCollection, objectArray, batch) // Recursively nested objects in mother array and children arrays
	{
		if (Array.isArray(objectArray))
		{
			for (let i = 0; i < objectArray.length; i++)
			{
				const useCol = (objectArray[i].folder === true) ? folderCollection : pageTypeCollection ;

				// Add batch operation
				batch.delete(useCol.doc(objectArray[i].id));
				
				// Check nested children
				if (objectArray[i].children && objectArray[i].children.length > 0) this.recursivelyAddFirestoreBatchDeletes(pageTypeCollection, folderCollection, objectArray[i].children, batch);
			}
		}
	},


	recursivelyAddFirestoreBatchMoveToTrash: function(firebaseTrashCollection, firebaseDeleteCollection, objectArray, batch, collectShared) // Recursively nested objects in mother array and children arrays
	{
		if (Array.isArray(objectArray))
		{
			for (let i = 0; i < objectArray.length; i++)
			{
				// Add batch operation
				if (objectArray[i].nodeType === 'content' || objectArray[i].nodeType === 'shared-content')
				{
					batch.set(firebaseTrashCollection.doc(objectArray[i].id), { trash: true }, { merge: true } );
					batch.set(firebaseTrashCollection.doc(objectArray[i].id).collection('document').doc('content'), { trash: true }, { merge: true } );
					if (collectShared) collectShared.push(objectArray[i].id);
				}
				else
				{
					batch.delete(firebaseDeleteCollection.doc(objectArray[i].id));
				}
				// Check nested children
				if (objectArray[i].children && objectArray[i].children.length > 0) this.recursivelyAddFirestoreBatchMoveToTrash(firebaseTrashCollection, firebaseDeleteCollection, objectArray[i].children, batch, collectShared);
			}
		}
	},


	recursivelyGetFirestoreStuffToTrashOrDelete: function(objectArray, collectArray) // Recursively nested objects in mother array and children arrays
	{
		if (Array.isArray(objectArray))
		{
			for (let i = 0; i < objectArray.length; i++)
			{
				// Add batch operation
				if (objectArray[i].nodeType === 'content' || objectArray[i].nodeType === 'shared-content')
				{
					//batch.set(firebaseTrashCollection.doc(objectArray[i].id), { trash: true }, { merge: true } );
					collectArray.push( { id: objectArray[i].id, type: 'trash' } );
				}
				else
				{
					collectArray.push( { id: objectArray[i].id, type: 'delete' } );
					//batch.delete(firebaseDeleteCollection.doc(objectArray[i].id));
				}
				// Check nested children
				if (objectArray[i].children && objectArray[i].children.length > 0) this.recursivelyGetFirestoreStuffToTrashOrDelete(objectArray[i].children, collectArray);
			}
		}
	},




	getObjectParentArrayById: function(objectArray, id) // Recursively nested objects in mother array and children arrays
	{
		let result = null;

		if (Array.isArray(objectArray))
		{
			for (let i = 0; i < objectArray.length; i++)
			{
				if (objectArray[i].id === id)
				{
					return objectArray;
				}
				else
				{
					if (objectArray[i].children && objectArray[i].children.length > 0) result = this.getObjectParentArrayById(objectArray[i].children, id);
					if (result != null) return result;
				}
			}
		}
		return null;
	},


	getObjectParentIdByChildId: function(objectArray, id, lastParentId = 'root') // Recursively nested objects in mother array and children arrays
	{
		let result = null;

		if (Array.isArray(objectArray))
		{
			for (let i = 0; i < objectArray.length; i++)
			{
				if (objectArray[i].id === id)
				{
					return lastParentId;
				}
				else
				{
					if (objectArray[i].children && objectArray[i].children.length > 0) result = this.getObjectParentIdByChildId(objectArray[i].children, id, objectArray[i].id);
					if (result != null) return result;
				}
			}
		}
		return null;
	},


	getObjectParentByChildId: function(objectArray, id, lastParent = null) // Recursively nested objects in mother array and children arrays
	{
		let result = null;

		if (Array.isArray(objectArray))
		{
			for (let i = 0; i < objectArray.length; i++)
			{
				if (objectArray[i].id === id)
				{
					return lastParent;
				}
				else
				{
					if (objectArray[i].children && objectArray[i].children.length > 0) result = this.getObjectParentByChildId(objectArray[i].children, id, objectArray[i]);
					if (result != null) return result;
				}
			}
		}
		return null;
	},


	updateTreeSortOrder: function(objectArray, open, prop = 'editorMetaData', subProp = 'treeNodePosition') // Recursively nested objects in mother array and children arrays
	{
		if (Array.isArray(objectArray))
		{
			this.sortBySubProperty(objectArray, prop, subProp);// 'editorMetaData', 'treeNodePosition'
		
			for (let i = 0; i < objectArray.length; i++)
			{
				// Check nested children
				if (objectArray[i].children)
				{
					if (objectArray[i].children.length > 0)
					{
						// Search recursive
						this.updateTreeSortOrder(objectArray[i].children, open, prop, subProp);
					}
				}
			}
		}
	},

	
	removeObjectFromArrayBasedOnSubObjectMatch(array, property, object)
	{
		const index = array.map(function(e) { return e[property]; }).indexOf(object);
		if (index > -1) array.splice(index, 1);
	},


	getArrayIndexOfSub(array, property, object)
	{
		return array.map(function(e) { return e[property]; }).indexOf(object);
	},


	/* sharedContentRootFinder: function(objectArray, firstShared = null) // Recursively nested objects in mother array and children arrays
	{
		if (Array.isArray(objectArray))
		{
			
			for (let i = 0; i < objectArray.length; i++)
			{
				// Check nested children
				if (objectArray[i].children)
				{
					if (firstShared) objectArray[i].rootSharedTreeGroupId = firstShared;
					
					if (objectArray[i].nodeType === 'shared-content' && !firstShared)
					{
						if (objectArray[i].children.length > 0)
						{
							this.sharedContentRootFinder(objectArray[i].children, objectArray[i].id);
						}
					}
					else
					{
						if (objectArray[i].children.length > 0)
						{
							this.sharedContentRootFinder(objectArray[i].children, firstShared);
						}
					}
				}
			}
		}
	}, */












	// #Todo: Sucky code, doesn't nest. Exists libraries on npm that can do this for us...
	convertPropertiesToPlainObject(classObject)
	{
		const returnObject = {};

		for (const property in classObject)
		{
			returnObject[property] = classObject[property];
		}
		return returnObject;
	},

	



    preventDefaults(e) {
		e.preventDefault()
		e.stopPropagation()
	},


	isElementHidden(el)
	{
		var style = window.getComputedStyle(el);
		return (style.display === 'none')
	},



	toJsSafeCamelCase(str)
	{
		str = str.replace(/[^a-zA-Z0-9 ]+/g, '');
		str = str.replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr, idx) => idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase()).replace(/\s+/g, '');
		if (!isNaN(str.charAt(0))) str = '_'+str;
		return str;
	},

	toJsSafeProperCaseNoNumbers(str)
	{
		str = str.replace(/[^a-zA-Z ]+/g, '');
		str = str.replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr) => ltr.toUpperCase()).replace(/\s+/g, '');
		return str;
	},

	slugify(string)
	{
		const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
		const p = new RegExp(a.split('').join('|'), 'g')

		return string.toString().toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w-]+/g, '') // Remove all non-word characters
			.replace(/--+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text
	},

	isFunction(functionToCheck)
	{
		return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
	},

	usl()
	{
		return '%2F';
	}


	/* setInputFilter(textbox, inputFilter)
	{
		["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event)
		{
			textbox.addEventListener(event, function()
			{
				if (inputFilter(this.value)) {
					this.oldValue = this.value;
					this.oldSelectionStart = this.selectionStart;
					this.oldSelectionEnd = this.selectionEnd;
				} else if (Object.prototype.hasOwnProperty.call(this, "oldValue")) {
				//} else if (this.hasOwnProperty("oldValue")) {
					this.value = this.oldValue;
					this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
				} else {
					this.value = "";
				}
			});
		});
	} */

	



};



export default agile;